var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
export class BaseCheckpointModel {
    constructor(checkpoint) {
        this.isDirty = false;
        this.type = checkpoint.type;
        this.comment = checkpoint.comment;
        this.discrepancy = checkpoint.discrepancy;
        this.researcherId = checkpoint.researcherId;
        this.verificationDate = checkpoint.verificationDate;
        this.verified = checkpoint.verificationDate != null;
        this.showComment = checkpoint.comment != '';
    }
    calculateVerificationDate() {
        if (!this.verified) {
            return '';
        }
        if (this.verificationDate != null) {
            return this.verificationDate;
        }
        return new Date().toISOString();
    }
}
__decorate([
    observable
], BaseCheckpointModel.prototype, "type", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "comment", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "discrepancy", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "researcherId", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "verificationDate", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "verified", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "showComment", void 0);
__decorate([
    observable
], BaseCheckpointModel.prototype, "isDirty", void 0);
__decorate([
    action
], BaseCheckpointModel.prototype, "calculateVerificationDate", null);
